import React, { Component } from 'react';

export class GroupRequest extends Component {
    constructor(props) {
        super(props);
        var programId = 0;
        try {
            var params = new URLSearchParams(window.location.search);
            var pid = params.get('programId'); if (pid) programId = parseInt(pid);
        } catch {}
        this.state = {
            form: { name:'', phone:'', email:'', line:'', pax:'', destination:'', programId, travelDate:'', budget:'', note:'' },
            submitting: false, done: false
        };
    }

    upd(field, val) { this.setState({ form: { ...this.state.form, [field]: val } }); }

    async submit() {
        var { form } = this.state;
        if (!form.name.trim() || !form.phone.trim()) { alert('กรุณากรอกชื่อและเบอร์โทร'); return; }
        this.setState({ submitting: true });
        try {
            var body = { ...form, pax: parseInt(form.pax) || 0, programId: parseInt(form.programId) || null };
            var r = await fetch('api/grouprequest', { method:'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(body) });
            if (!r.ok) throw new Error('submit failed');
            this.setState({ submitting: false, done: true });
        } catch (e) {
            this.setState({ submitting: false });
            alert('ส่งคำขอไม่สำเร็จ: ' + e.message);
        }
    }

    render() {
        var { form, submitting, done } = this.state;
        if (done) {
            return (
                <div style={{ background:'#f4f3ef', minHeight:'100vh', padding:'40px 20px' }}>
                    <div className="container" style={{ maxWidth:600 }}>
                        <div style={{ background:'#fff', borderRadius:12, padding:40, textAlign:'center', boxShadow:'0 4px 20px rgba(0,0,0,0.08)' }}>
                            <i className="fas fa-check-circle" style={{ fontSize:64, color:'#28a745' }}></i>
                            <h3 style={{ marginTop:16, fontWeight:800 }}>ส่งคำขอเรียบร้อย</h3>
                            <p style={{ color:'#666' }}>ทีมงานจะติดต่อกลับโดยเร็วที่สุดครับ/ค่ะ</p>
                            <a href="/" className="btn btn-danger mt-3"><i className="fas fa-home"></i> กลับหน้าแรก</a>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div style={{ background:'#f4f3ef', minHeight:'100vh', padding:'30px 20px' }}>
                <div className="container" style={{ maxWidth:720 }}>
                    <div style={{ background:'#fff', borderRadius:12, padding:30, boxShadow:'0 4px 20px rgba(0,0,0,0.08)' }}>
                        <h3 style={{ color:'#dc3545', fontWeight:800, marginBottom:6 }}><i className="fas fa-users"></i> จัดกรุ๊ปส่วนตัว</h3>
                        <p style={{ color:'#888', fontSize:14, marginBottom:24 }}>กรอกข้อมูลเพื่อให้เจ้าหน้าที่ติดต่อกลับ</p>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>ชื่อผู้ติดต่อ *</label>
                                <input className="form-control" value={form.name} onChange={e=>this.upd('name',e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>เบอร์โทร *</label>
                                <input className="form-control" value={form.phone} onChange={e=>this.upd('phone',e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>อีเมล</label>
                                <input className="form-control" type="email" value={form.email} onChange={e=>this.upd('email',e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>LINE ID</label>
                                <input className="form-control" value={form.line} onChange={e=>this.upd('line',e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>จำนวนผู้เดินทาง</label>
                                <input className="form-control" type="number" value={form.pax} onChange={e=>this.upd('pax',e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>วันเดินทาง (โดยประมาณ)</label>
                                <input className="form-control" type="date" value={form.travelDate} onChange={e=>this.upd('travelDate',e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>งบต่อท่าน</label>
                                <input className="form-control" placeholder="เช่น 30,000-50,000" value={form.budget} onChange={e=>this.upd('budget',e.target.value)} />
                            </div>
                            <div className="col-12">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>จุดหมาย / ประเทศที่สนใจ</label>
                                <input className="form-control" placeholder="เช่น ญี่ปุ่น, ยุโรป, เซี่ยงไฮ้" value={form.destination} onChange={e=>this.upd('destination',e.target.value)} />
                            </div>
                            <div className="col-12">
                                <label className="form-label" style={{ fontSize:13, fontWeight:600 }}>รายละเอียดเพิ่มเติม</label>
                                <textarea className="form-control" rows="4" placeholder="ความต้องการพิเศษ เช่น อาหาร โรงแรม วันที่ต้องการ ฯลฯ" value={form.note} onChange={e=>this.upd('note',e.target.value)}></textarea>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between mt-4">
                            <a href="/" className="btn btn-outline-secondary"><i className="fas fa-arrow-left"></i> กลับ</a>
                            <button className="btn btn-danger" disabled={submitting} onClick={()=>this.submit()}>
                                <i className="fas fa-paper-plane"></i> {submitting ? 'กำลังส่ง...' : 'ส่งคำขอ'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
